import request from '../util/request'

// 获取用户详细信息
export function getInfo() {
    return request({
        url: '/api/account/memberInfo',
        method: 'get'
    })
}
// 批量配置批次
export function batchUpdateSource(id,memo) {
  return request({
    url: '/api/account/updateDouyinProjectDoujiaMemo/'+id,
    method: 'post',
    params: {
      memo:memo
    }
  })
}
//本地推项目列表
export function memberOrderListBen(query) {
    return request({
      url: '/api/account/selectDouyinProjectLocalList',
      method: 'post',
      data: query
    })
}

//抖+项目列表
export function memberOrderListDj(query) {
    return request({
      url: '/api/account/selectDouyinProjectDoujiaList',
      method: 'post',
      data: query
    })
}

// 获取客服
export function getService() {
  return request({
    url: '/api/member/getService',
    method: 'get'
  })
}

export function showNewMemberNotice() {
  return request({
    url: '/api/member/showNewMemberNotice',
    method: 'get'
  })
}

export function memberTopUpByCode(accountType, amount) {
  return request({
    url: '/api/member/memberTopUpByCode/' + accountType + '/' + amount,
    method: 'get'
  })
}

//充值
export function memberTopUpPc(accountType, amount) {
  return request({
    url: '/api/member/memberTopUpPc/' + accountType + '/' + amount,
    method: 'get'
  })
}

export function memberTopUpDiangmianfu(accountType, amount) {
  return request({
    url: '/api/member/memberTopUpDiangmianfu/' + accountType + '/' + amount,
    method: 'get'
  })
}

export function tradeInfo(id) {
  return request({
    url: 'api/account/queryAcccountTradeStatus/' + id,
    method: 'get'
  })
}

export function memberOrderList(query) {
    return request({
      url: '/api/account/projectList',
      method: 'get',
      params: query
    })
}

export function getMembersOrders(query) {
    return request({
      url: '/api/member/getMembersOrders',
      method: 'get',
      params: query
    })
}

export function updatePwd(oldPassword, newPassword) {
  const data = {
    oldPassword: oldPassword,
    newPassword: newPassword
  }
  return request({
    url: '/api/account/updatePwd',
    method: 'put',
    data: data
  })
}

export function updatePwdPay(oldPassword, newPassword,isPay) {
  const data = {
    oldPassword: oldPassword,
    newPassword: newPassword,
    isPay:isPay
  }
  return request({
    url: '/api/account/payUpdatePwd',
    method: 'put',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js